import type { TranslationMessages } from './types';

export const bugReport: TranslationMessages = {
  title: 'Report a Bug',
  description:
    'Help us improve by reporting bugs. Include a screenshot and describe what happened.',
  screenshot: 'Screenshot',
  captureScreenshot: 'Capture Screenshot',
  capturing: 'Capturing...',
  uploadScreenshot: 'Upload Screenshot',
  drawCircle: 'Circle',
  drawArrow: 'Arrow',
  drawRectangle: 'Rectangle',
  drawCustom: 'Draw Custom Shape',
  clearAnnotations: 'Clear All Annotations',
  removeAnnotation: 'Remove this annotation',
  zoomIn: 'Zoom In',
  zoomOut: 'Zoom Out',
  resetZoom: 'Reset Zoom',
  annotationType: {
    circle: 'Circle',
    rectangle: 'Rectangle',
    arrow: 'Arrow',
    custom: 'Custom',
  },
  descriptionLabel: 'What went wrong?',
  descriptionPlaceholder: 'Describe the bug you encountered...',
  expectationLabel: 'What did you expect?',
  expectationPlaceholder: 'Describe what you expected to happen...',
  submit: 'Submit Report',
  submitting: 'Submitting...',
  revealSensitiveData: 'Reveal Sensitive Data',
  hideSensitiveData: 'Hide Sensitive Data',
  screenshotEmpty: 'Screenshot capture returned empty data',
  captureFailed: 'Failed to capture screenshot',
  descriptionRequired: 'Please provide a description',
  sentSuccessfully: 'Bug report sent successfully',
  submitFailed: 'Failed to submit bug report',
  reauthTitle: 'Re-authentication Required',
  reauthDescription:
    'Please enter your password to reveal sensitive data in the screenshot. This is required for security purposes.',
};
